import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import infowidgets from '../../../data/infowidgets.json';

class Infowidgets extends Component {
    render() {
        return (
            <section className="slider-bottom">
                <div className="container">
                    <div className="row">
                        {/* Data */}
                        {infowidgets.map((item, i) => (
                            <div className="col-lg-4" key={i}>
                                <div className="box-1">
                                    <div className={"bx-wrapper " + item.boxstyle}> <i className={item.icon} />
                                        <h4 className="text-custom-white">{item.title}</h4>
                                        <p>{item.text}</p>
                                        <Link to="/about" className="pricingTable-signup white">Read More</Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                        {/* Data */}
                    </div>
                </div>
            </section>
        );
    }
}

export default Infowidgets;